export default "__VITE_ASSET__BJeX7eoB__"